import styled from "styled-components";
import { Select as antdSelect } from "antd";
import { DownOutlined } from "@ant-design/icons";

const BaseSelect = styled(antdSelect)`
  width: 100%;

  &.ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    background-color: transparent;
    color: ${(props) => props.theme.colors.greyTwo} !important;
  }

  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none !important;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyOne} !important;
    border-radius: 0 !important;
    padding: 0 24px 0 0 !important;
    height: 32px;
    align-items: center;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-search {
    left: 0 !important;
    right: 24px !important;
    margin-inline-start: 0 !important;
    width: calc(100% - 24px) !important;
  }

  &.ant-select-single
    .ant-select-selector
    .ant-select-selection-search-input {
    height: 30px !important;
    font-size: 16px !important;
    line-height: 28px !important;
    padding: 0 !important;
    text-align: left !important;
  }

  &.ant-select-single .ant-select-selector .ant-select-selection-item,
  &.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 30px !important;
    font-size: 16px;
    left: 0 !important;
    inset-inline-start: 0 !important;
    padding: 0 !important;
    color: ${(props) => props.theme.colors.black} !important;
  }

  &.ant-select-single
    .ant-select-selector
    .ant-select-selection-placeholder {
    color: ${(props) => props.theme.colors.black} !important;
  }

  .ant-select-arrow {
    right: 0;
  }
`;

export function Select({
  getPopupContainer,
  dropdownMatchSelectWidth = true,
  style,
  ...props
}: any): JSX.Element {
  return (
    <BaseSelect
      suffixIcon={<DownOutlined style={{ color: "#65696A" }} />}
      dropdownMatchSelectWidth={dropdownMatchSelectWidth}
      getPopupContainer={
        getPopupContainer ||
        ((triggerNode: HTMLElement) =>
          triggerNode.parentElement || document.body)
      }
      style={{ width: "100%", ...(style || {}) }}
      {...props}
    />
  );
}
